import { render } from "./ElementNavigation.vue?vue&type=template&id=4f9229fc&scoped=true"
import script from "./ElementNavigation.vue?vue&type=script&lang=js"
export * from "./ElementNavigation.vue?vue&type=script&lang=js"

import "./ElementNavigation.vue?vue&type=style&index=0&id=4f9229fc&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9229fc"]])

export default __exports__